<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-0(:title="$t('mantra')")

  section.u-mt-md
    .grid.is-tablet-6
      .column.u-mb-sm(v-for="item,idx in $t('sec1Items')")
        h4 {{item.title}}
        p {{item.desc}}

  section.u-mt-md
    .grid
      .column.is-widescreen-6
        AppTitle.u-mb-mi(:title="$t('sec2')" tag="h2")
      .column.is-widescreen-6
        .grid.is-tablet-12
          .column.u-mb-sm(v-for="item,idx in $t('sec2Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md.u-mb-md
    AppLink(to="/ordering" :title="$t('cta')" class="button-link is-large " v-html="$t('cta')")

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:image',
          name: 'og:image',
          property: 'og:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          property: 'twitter:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Calligraphy and lettering",
    "pageDesc":"Custom calligraphy that supports your brand, event or social media presence. Whether you are working online or offline, we help you have a ditsinughsed look and feel.",
    "mantra":"Custom calligraphy for |enhanced personality.",
    "sec1Items":{
      "1":{
        "title":"Custom calligraphy",
        "desc":"Blending both digital and hand lettering techniques to come up with a unique calligraphy style that matches with your brand identity."
      },
      "2":{
        "title":"Spot calligraphy",
        "desc":"Not looking for much words? Leverage on the spot calligraphy and have a custom one piece that can be used on your packaging or website graphics."
      }
    },
    "sec2":"Add a rebellious touch to your brand identity with custom hand lettering that distinguishes your prints and online materials.",
    "sec2Items":{
      "1":{
        "title":"Event calligraphy",
        "desc":"Having a classy ceremony or maybe need a special occasion design? We help you create all the stationary needed starting with invitations to inside the venue prints."
      },
      "2":{
        "title":"Logo design",
        "desc":"Stepping out of the norm with a custom logo design for your brand personality and leveraging on the powers of lettering. Whether beauty, fashion or any other industry,  we help you figure out the matching combination."
      },
      "3":{
        "title":"Editorial design",
        "desc":"Creating posters with free style to enhance that can be used on your website, social media assets or your prints."
      }
    },
    "cta":"Leverage on the power of <br> free handwriting."
  },
  "ar": {
    "pageTitle":"كاليجرافي",
    "pageDesc":"نوفر لك خط مخصص يدعم علامتك التجارية والفعاليات والسوشيال ميديا، مهما كانت احتياجاتك سوف نمنحك المظهر والانطباع الذي تحتاجه.",
    "mantra":"صمم الخط المعبر |عنك عبر الكاليجرافي.",
    "sec1Items":{
      "1":{
        "title":"الخط مخصص",
        "desc":"ادمج بين تقنيات الحروف الرقمية واليدوية للوصول إلى نمط الخط الفريد الذي يتوافق مع هوية علامتك التجارية."
      },
      "2":{
        "title":"سبوت كاليجرافي",
        "desc":"لا تبحث عن الكثير من الكلمات؟ استفد من سبوت كاليجرافي واحصل على خط مخصص يمكن استخدامه في التغليف أو رسومات موقعك."
      }
    },
    "sec2":"أضف لمسة جريئة إلى هوية علامتك التجارية باستخدام حروف يدوية مخصصة التي تُميز مطبوعاتك والمواد الخاصة بك الموجودة على الانترنت.",
    "sec2Items":{
      "1":{
        "title":"خط الفاعليات",
        "desc":"تحضر لفاعلية أو تحتاج تصميم لمناسبة خاصة؟! سوف نساعدك على إنشاء جميع الأدوات اللازمة بدءًا من الدعوات إلى المطبوعات داخل المكان."
      },
      "2":{
        "title":"تصميم شعار",
        "desc":"اخرج عن المألوف وصمم  شعار مخصص لعلامتك التجارية واستفيد من شكل الحروف. مهما كانت الصناعة التي تعمل بها الموضة أو التجميل… وغيرها سوف نساعدك على تصميم ما يتناسب معك."
      },
      "3":{
        "title":"تصميم المطبوعات",
        "desc":"صمم بوسترات بأسلوب حر حيث يمكنك استخدامها على موقعك أو أصول وسائل التواصل الإجتماعي أو المطبوعات الخاصة بك."
      }
    },
    "cta":"استغل تأثير الكتابة <br> الحرة. "
  }
}
</i18n>
